import { type IMobileApplications, useApp } from "@next-platform/client-common-core";

import { type BrandedMobileApplication, getBrandedMobileApplications, getCurrentBrandMobileApplications } from "./getBrandedMobileApplications";

type DownloadMobileApplicationsConfig = {
  brandedApplications: BrandedMobileApplication[];
  androidApplication: IMobileApplications | undefined;
  iosApplication: IMobileApplications | undefined;
  hasMobileApplications: boolean;
  isMobileApplicationsReady: boolean;
};

export default function useDownloadMobileApplicationsConfig(): DownloadMobileApplicationsConfig {
  const { appSettings, applicationId, mobileApplications } = useApp();
  const currentApplicationId = applicationId ?? "";
  const brandedApplications = getBrandedMobileApplications({ mobileApplications });
  const currentBrandApplications = getCurrentBrandMobileApplications({
    brandedApplications,
    currentApplicationId,
  });

  return {
    brandedApplications,
    androidApplication: currentBrandApplications?.androidApplication,
    iosApplication: currentBrandApplications?.iosApplication,
    hasMobileApplications: brandedApplications.some(({ androidApplication, iosApplication }) => Boolean(androidApplication || iosApplication)),
    // Settings load/failure is gated by AppSettingsGate; null here means still loading.
    isMobileApplicationsReady: appSettings !== null,
  };
}
